import { createContext, ReactNode, useCallback, useContext, useMemo, useState } from 'react';
import { VOID } from './typeUtils';
import { Map as olMap } from 'ol';

export const InitialLocationContext = createContext<{
  updateMapLocation: (olmap: olMap) => void;
  retainMapLocation: (olmap: olMap) => void;
}>({
  updateMapLocation: VOID,
  retainMapLocation: VOID,
});

export const InitialLocationProvider = ({ children }: { children: ReactNode }) => {
  const [initialLocation, setInitialLocation] = useState<number[] | undefined>();

  const retainMapLocation = useCallback((olmap: olMap) => {
    const view = olmap.getView();
    const center = view.getCenter();
    if (center) {
      setInitialLocation([...center, view.getZoom() ?? 0]);
    }
  }, []);

  const updateMapLocation = useCallback(
    (olmap: olMap) => {
      if (initialLocation) {
        olmap?.getView().setCenter([initialLocation[0], initialLocation[1]]);
        const zoomLevel = initialLocation?.[2];
        if (zoomLevel) {
          olmap?.getView().setZoom(zoomLevel);
        }
      }
    },
    [initialLocation],
  );

  const value = useMemo(
    () => ({
      updateMapLocation,
      retainMapLocation,
    }),
    [updateMapLocation, retainMapLocation],
  );
  return (
    <InitialLocationContext.Provider value={value}>{children}</InitialLocationContext.Provider>
  );
};

export const useInitialLocation = () => useContext(InitialLocationContext);
